import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BadgeComponent} from "./badge/badge.component";
import {ActivityComponent} from "./activity/activity.component";
import {IonicModule} from "@ionic/angular";
import {PointsComponent} from "./points/points.component";
import {BadgesComponent} from "./badges/badges.component";
import {FaqComponent} from "./faq/faq.component";
import {FooterComponent} from "./footer/footer.component";
import {QuizComponent} from "./quiz/quiz.component";
import {HeaderPinkComponent} from "./header-pink/header-pink.component";
import {OnBoardingComponent} from "./on-boarding/on-boarding.component";
import {ContactFormComponent} from "./contact-form/contact-form.component";
import {FormsModule} from "@angular/forms";
import {RouterLinkActive, RouterModule} from "@angular/router";
import {InfoActivityComponent} from "./info-activity/info-activity.component";
import {CustomListonoszComponent} from "./custom-listonosz/custom-listonosz.component";
import {AddressFormComponent} from "./address-form/address-form.component";
import {LoadingComponent} from "./loading/loading.component";
import {PseudoPopupComponent} from "./pseudo-popup/pseudo-popup.component";
import {FortuneWheelComponent} from "./fortune-wheel/fortune-wheel.component";


@NgModule({
  declarations: [
    ActivityComponent,
    AddressFormComponent,
    BadgeComponent,
    BadgesComponent,
    ContactFormComponent,
    CustomListonoszComponent,
    FaqComponent,
    FooterComponent,
    FortuneWheelComponent,
    HeaderPinkComponent,
    InfoActivityComponent,
    LoadingComponent,
    PointsComponent,
    PseudoPopupComponent,
    QuizComponent,
    OnBoardingComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    RouterLinkActive
  ],
  exports: [
    ActivityComponent,
    AddressFormComponent,
    BadgeComponent,
    BadgesComponent,
    ContactFormComponent,
    CustomListonoszComponent,
    FaqComponent,
    FooterComponent,
    HeaderPinkComponent,
    InfoActivityComponent,
    LoadingComponent,
    PointsComponent,
    PseudoPopupComponent,
    QuizComponent,
    OnBoardingComponent
  ]
})
export class ComponentsModule { }
